import { $CombinedState } from "redux";
import { stateType } from "../../store";
import { initialState as cartState } from "./cart";
import { initialState as commonReloadState } from "./common_reload";
import { initialState as commonState } from "./common";
import { initialState as orderState } from "./order";
import { initialState as settingsState } from "./settings";
import { initialState as accountState } from "./account";

export const State: Omit<stateType, typeof $CombinedState> = {
  cartReducer: cartState,
  commonReloadReducer: commonReloadState,
  commonReducer: commonState,
  orderReducer: orderState,
  settingsReducer: settingsState,
  accountReducer: accountState
};
